import { environment } from '@hakimo-ui/hakimo/environments';

export const SENTRY_DSN =
  'https://2009dd5c57a94d6b0ed03e22514ec7b3@o1288507.ingest.sentry.io/4505861277155328';

export const INTERCOM_APP_ID = 'umr1vk9w';

export const isLocal = environment.name === 'LOCAL';
